import { defineSlotRecipe, defineStyle } from '@chakra-ui/react';

export const menuSlotRecipe = defineSlotRecipe({
  slots: ['groupTitle', 'trigger'],
  base: {
    groupTitle: defineStyle({
      fontWeight: 'semibold',
      fontSize: 'sm',
      margin: 3,
    }),
    trigger: defineStyle({
      transitionProperty: 'common',
      transitionDuration: 'normal',
      _hover: { bg: 'gray.100' },
      _active: { bg: 'gray.100' },
      _expanded: { bg: 'gray.100' },
    }),
  },
});

export default menuSlotRecipe;
